(function () {
  'use strict';
  if (window.__owCbV1) return;
  window.__owCbV1 = true;
  var W = window, D = document, HTML = D.documentElement;
  var OW_CUR = {"USD":["$",2,"US dollar"],"EUR":["\u20ac",2,"Euro"],"GBP":["\u00a3",2,"British pound"],"CAD":["CA$",2,"Canadian dollar"],"AUD":["A$",2,"Australian dollar"],"NZD":["NZ$",2,"New Zealand dollar"],"JPY":["\u00a5",0,"Japanese yen"],"CHF":["CHF ",2,"Swiss franc"],"SEK":["SEK ",2,"Swedish krona"],"NOK":["NOK ",2,"Norwegian krone"],"DKK":["DKK ",2,"Danish krone"],"PLN":["PLN ",2,"Polish z\u0142oty"],"CZK":["CZK ",2,"Czech koruna"],"HUF":["HUF ",2,"Hungarian forint"],"RON":["RON ",2,"Romanian leu"],"ISK":["ISK ",0,"Icelandic kr\u00f3na"],"TRY":["\u20ba",2,"Turkish lira"],"ILS":["\u20aa",2,"Israeli shekel"],"INR":["\u20b9",2,"Indian rupee"],"SGD":["S$",2,"Singapore dollar"],"HKD":["HK$",2,"Hong Kong dollar"],"MXN":["MX$",2,"Mexican peso"],"BRL":["R$",2,"Brazilian real"],"ZAR":["ZAR ",2,"South African rand"],"KRW":["\u20a9",0,"South Korean won"],"CNY":["CN\u00a5",2,"Chinese yuan"],"PHP":["\u20b1",2,"Philippine peso"],"THB":["\u0e3f",2,"Thai baht"],"MYR":["RM ",2,"Malaysian ringgit"],"IDR":["IDR ",2,"Indonesian rupiah"],"AED":["AED ",2,"UAE dirham"],"AFN":["AFN ",2,"Afghan afghani"],"ALL":["ALL ",2,"Albanian lek"],"AMD":["AMD ",2,"Armenian dram"],"AOA":["AOA ",2,"Angolan kwanza"],"ARS":["ARS ",2,"Argentine peso"],"AWG":["AWG ",2,"Aruban florin"],"AZN":["AZN ",2,"Azerbaijani manat"],"BAM":["BAM ",2,"Bosnia-Herzegovina convertible mark"],"BBD":["BBD ",2,"Barbadian dollar"],"BDT":["BDT ",2,"Bangladeshi taka"],"BHD":["BHD ",3,"Bahraini dinar"],"BIF":["BIF ",0,"Burundian franc"],"BMD":["BMD ",2,"Bermudian dollar"],"BND":["BND ",2,"Brunei dollar"],"BOB":["BOB ",2,"Bolivian boliviano"],"BSD":["BSD ",2,"Bahamian dollar"],"BTN":["BTN ",2,"Bhutanese ngultrum"],"BWP":["BWP ",2,"Botswana pula"],"BYN":["BYN ",2,"Belarusian ruble"],"BZD":["BZD ",2,"Belize dollar"],"CDF":["CDF ",2,"Congolese franc"],"CLP":["CLP ",0,"Chilean peso"],"COP":["COP ",2,"Colombian peso"],"CRC":["\u20a1",2,"Costa Rican col\u00f3n"],"CVE":["CVE ",2,"Cape Verdean escudo"],"DJF":["DJF ",0,"Djiboutian franc"],"DOP":["DOP ",2,"Dominican peso"],"DZD":["DZD ",2,"Algerian dinar"],"EGP":["EGP ",2,"Egyptian pound"],"ERN":["ERN ",2,"Eritrean nakfa"],"ETB":["ETB ",2,"Ethiopian birr"],"FJD":["FJD ",2,"Fijian dollar"],"FKP":["FKP ",2,"Falkland Islands pound"],"GEL":["GEL ",2,"Georgian lari"],"GHS":["GH\u20b5",2,"Ghanaian cedi"],"GIP":["GIP ",2,"Gibraltar pound"],"GMD":["GMD ",2,"Gambian dalasi"],"GNF":["GNF ",0,"Guinean franc"],"GTQ":["GTQ ",2,"Guatemalan quetzal"],"GYD":["GYD ",2,"Guyanese dollar"],"HNL":["HNL ",2,"Honduran lempira"],"HTG":["HTG ",2,"Haitian gourde"],"IQD":["IQD ",3,"Iraqi dinar"],"JMD":["JMD ",2,"Jamaican dollar"],"JOD":["JOD ",3,"Jordanian dinar"],"KES":["KES ",2,"Kenyan shilling"],"KGS":["KGS ",2,"Kyrgyzstani som"],"KHR":["KHR ",2,"Cambodian riel"],"KMF":["KMF ",0,"Comorian franc"],"KWD":["KWD ",3,"Kuwaiti dinar"],"KYD":["KYD ",2,"Cayman Islands dollar"],"KZT":["\u20b8",2,"Kazakhstani tenge"],"LAK":["\u20ad",2,"Lao kip"],"LKR":["LKR ",2,"Sri Lankan rupee"],"LRD":["LRD ",2,"Liberian dollar"],"LSL":["LSL ",2,"Lesotho loti"],"LYD":["LYD ",3,"Libyan dinar"],"MAD":["MAD ",2,"Moroccan dirham"],"MDL":["MDL ",2,"Moldovan leu"],"MGA":["MGA ",2,"Malagasy ariary"],"MKD":["MKD ",2,"Macedonian denar"],"MMK":["MMK ",2,"Myanmar kyat"],"MNT":["\u20ae",2,"Mongolian t\u00f6gr\u00f6g"],"MOP":["MOP ",2,"Macanese pataca"],"MRU":["MRU ",2,"Mauritanian ouguiya"],"MUR":["MUR ",2,"Mauritian rupee"],"MVR":["MVR ",2,"Maldivian rufiyaa"],"MWK":["MWK ",2,"Malawian kwacha"],"MZN":["MZN ",2,"Mozambican metical"],"NAD":["NAD ",2,"Namibian dollar"],"NGN":["\u20a6",2,"Nigerian naira"],"NIO":["NIO ",2,"Nicaraguan c\u00f3rdoba"],"NPR":["NPR ",2,"Nepalese rupee"],"OMR":["OMR ",3,"Omani rial"],"PAB":["PAB ",2,"Panamanian balboa"],"PEN":["PEN ",2,"Peruvian sol"],"PGK":["PGK ",2,"Papua New Guinean kina"],"PKR":["PKR ",2,"Pakistani rupee"],"PYG":["\u20b2",0,"Paraguayan guaran\u00ed"],"QAR":["QAR ",2,"Qatari riyal"],"RSD":["RSD ",2,"Serbian dinar"],"RUB":["\u20bd",2,"Russian ruble"],"RWF":["RWF ",0,"Rwandan franc"],"SAR":["SAR ",2,"Saudi riyal"],"SBD":["SBD ",2,"Solomon Islands dollar"],"SCR":["SCR ",2,"Seychellois rupee"],"SDG":["SDG ",2,"Sudanese pound"],"SHP":["SHP ",2,"Saint Helena pound"],"SLE":["SLE ",2,"Sierra Leonean leone"],"SOS":["SOS ",2,"Somali shilling"],"SRD":["SRD ",2,"Surinamese dollar"],"SSP":["SSP ",2,"South Sudanese pound"],"STN":["STN ",2,"S\u00e3o Tom\u00e9 and Pr\u00edncipe dobra"],"SZL":["SZL ",2,"Eswatini lilangeni"],"TJS":["TJS ",2,"Tajikistani somoni"],"TMT":["TMT ",2,"Turkmenistani manat"],"TND":["TND ",3,"Tunisian dinar"],"TOP":["TOP ",2,"Tongan pa\u02bbanga"],"TTD":["TTD ",2,"Trinidad and Tobago dollar"],"TWD":["NT$",2,"New Taiwan dollar"],"TZS":["TZS ",2,"Tanzanian shilling"],"UAH":["\u20b4",2,"Ukrainian hryvnia"],"UGX":["UGX ",0,"Ugandan shilling"],"UYU":["UYU ",2,"Uruguayan peso"],"UZS":["UZS ",2,"Uzbekistani som"],"VND":["\u20ab",0,"Vietnamese \u0111\u1ed3ng"],"VUV":["VUV ",0,"Vanuatu vatu"],"WST":["WST ",2,"Samoan t\u0101l\u0101"],"XAF":["XAF ",0,"Central African CFA franc"],"XCD":["EC$",2,"East Caribbean dollar"],"XCG":["XCG ",2,"Caribbean guilder"],"XOF":["XOF ",0,"West African CFA franc"],"XPF":["XPF ",0,"CFP franc"],"YER":["YER ",2,"Yemeni rial"],"ZMW":["ZMW ",2,"Zambian kwacha"]};
/* code given and without decimals (JPY / KRW / ISK / VND ...): rounded ONCE to the whole unit (x 100); with 3 (KWD / BHD ...):
   once to the thousandth (a tenth of a "cent") \u2014 exactly like fx.ts convertCents. */
function owConv(c, rate, code) {
  if (!isFinite(c) || !isFinite(rate) || !(rate > 0)) return NaN;
  var raw = Math.round(c * rate * 1e6) / 1e6;
  var info = code && Object.prototype.hasOwnProperty.call(OW_CUR, code) ? OW_CUR[code] : null;
  if (info && info[1] === 0) { var u = raw / 100; return (u >= 0 ? Math.floor(u + 0.5) : -Math.floor(-u + 0.5)) * 100; }
  if (info && info[1] === 3) { var m = Math.round(raw * 1e7) / 1e6; return (m >= 0 ? Math.floor(m + 0.5) : -Math.floor(-m + 0.5)) / 10; }
  return raw >= 0 ? Math.floor(raw + 0.5) : -Math.floor(-raw + 0.5);
}
function owFormatOk(f) {
  if (f == null || f === '') return true;
  f = String(f).replace(/&#0*36;|&#x0*24;|&dollar;/gi, '$').replace(/<[^>]*>/g, '|');
  return /(^|[^A-Za-z0-9$])\$\s?\{\{\s*amount\s*\}\}/.test(f);
}
function owGroup(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
function owFmt(cents, code) {
  if (!isFinite(cents)) return '';
  var info = Object.prototype.hasOwnProperty.call(OW_CUR, code) ? OW_CUR[code] : null, sym = info ? info[0] : code + ' ', dec = info ? info[1] : 2;
  var neg = cents < 0, abs = Math.abs(cents), body;
  if (dec === 0) body = owGroup(String(Math.floor(abs / 100 + 0.5)));
  else if (dec === 3) {
    var mils = Math.round(abs * 10), w3 = Math.floor(mils / 1000), f3 = String(mils - w3 * 1000);
    while (f3.length < 3) f3 = '0' + f3;
    body = owGroup(String(w3)) + '.' + f3;
  } else {
    var whole = Math.floor(abs / 100), frac = String(abs - whole * 100);
    if (frac.length < 2) frac = '0' + frac;
    body = owGroup(String(whole)) + '.' + frac;
  }
  return (neg ? '-' : '') + sym + body;
}
/* "$8.99", "$8.99 USD", "$1,234.5" inside any text; never "CA$" / "A$" / "US$" (a letter before the $). */
var OW_MONEY_RE = /(^|[^A-Za-z0-9$])\$[ \u00a0]?((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?)(?:[ \u00a0]?USD\b)?/g;
function owConvertText(t, rate, code) {
  if (!t || t.indexOf('$') === -1 || !(rate > 0)) return null;
  var hit = false;
  var out = t.replace(OW_MONEY_RE, function (m, pre, num) {
    var c = Math.round(parseFloat(num.replace(/,/g, '')) * 100);
    if (!isFinite(c)) return m;
    hit = true;
    return pre + owFmt(owConv(c, rate, code), code);
  });
  return hit ? out : null;
}

  var FLAG_SVG = {"USD":"20 14|<rect width=\"20\" height=\"14\" fill=\"#fff\"/><path d=\"M0 0h20v1.08H0zM0 2.15h20v1.08H0zM0 4.31h20v1.08H0zM0 6.46h20v1.08H0zM0 8.62h20v1.08H0zM0 10.77h20v1.08H0zM0 12.92h20V14H0z\" fill=\"#b22234\"/><rect width=\"8\" height=\"7.54\" fill=\"#3c3b6e\"/>","GBP":"60 30|<rect width=\"60\" height=\"30\" fill=\"#012169\"/><path d=\"M0,0 60,30M60,0 0,30\" stroke=\"#fff\" stroke-width=\"6\"/><path d=\"M0,0 60,30M60,0 0,30\" stroke=\"#c8102e\" stroke-width=\"2\"/><path d=\"M30,0v30M0,15h60\" stroke=\"#fff\" stroke-width=\"10\"/><path d=\"M30,0v30M0,15h60\" stroke=\"#c8102e\" stroke-width=\"6\"/>","CAD":"40 20|<rect width=\"40\" height=\"20\" fill=\"#fff\"/><rect width=\"10\" height=\"20\" fill=\"#d52b1e\"/><rect x=\"30\" width=\"10\" height=\"20\" fill=\"#d52b1e\"/><path d=\"M20 4l1.2 2.4 1.6-.6-.6 3.4 2-1.6.4 1.2 2-.4-.8 2 .8.4-3.4 2.6.4 1.2-3.4-.4V17h-.6v-2.8l-3.4.4.4-1.2-3.4-2.6.8-.4-.8-2 2 .4.4-1.2 2 1.6-.6-3.4 1.6.6z\" fill=\"#d52b1e\"/>","AUD":"40 20|<rect width=\"40\" height=\"20\" fill=\"#012169\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#fff\" stroke-width=\"2\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#c8102e\" stroke-width=\".8\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#fff\" stroke-width=\"3\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#c8102e\" stroke-width=\"1.8\"/><g fill=\"#fff\"><circle cx=\"10\" cy=\"15\" r=\"1.8\"/><circle cx=\"30\" cy=\"4\" r=\".9\"/><circle cx=\"26\" cy=\"9\" r=\".9\"/><circle cx=\"33\" cy=\"8\" r=\".9\"/><circle cx=\"30\" cy=\"16\" r=\".9\"/><circle cx=\"31.5\" cy=\"11\" r=\".5\"/></g>","EUR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#039\"/><g fill=\"#fc0\"><circle cx=\"15\" cy=\"4\" r=\".9\"/><circle cx=\"18\" cy=\"4.8\" r=\".9\"/><circle cx=\"20.2\" cy=\"7\" r=\".9\"/><circle cx=\"21\" cy=\"10\" r=\".9\"/><circle cx=\"20.2\" cy=\"13\" r=\".9\"/><circle cx=\"18\" cy=\"15.2\" r=\".9\"/><circle cx=\"15\" cy=\"16\" r=\".9\"/><circle cx=\"12\" cy=\"15.2\" r=\".9\"/><circle cx=\"9.8\" cy=\"13\" r=\".9\"/><circle cx=\"9\" cy=\"10\" r=\".9\"/><circle cx=\"9.8\" cy=\"7\" r=\".9\"/><circle cx=\"12\" cy=\"4.8\" r=\".9\"/></g>","THB":"30 20|<rect width=\"30\" height=\"20\" fill=\"#a51931\"/><rect y=\"3.33\" width=\"30\" height=\"16.67\" fill=\"#f4f5f8\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#2d2a4a\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#f4f5f8\"/><rect y=\"16.67\" width=\"30\" height=\"3.33\" fill=\"#a51931\"/>","NZD":"40 20|<rect width=\"40\" height=\"20\" fill=\"#012169\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#fff\" stroke-width=\"2\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#c8102e\" stroke-width=\".8\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#fff\" stroke-width=\"3\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#c8102e\" stroke-width=\"1.8\"/><g fill=\"#c8102e\" stroke=\"#fff\" stroke-width=\".4\"><circle cx=\"30\" cy=\"4\" r=\"1\"/><circle cx=\"26\" cy=\"9\" r=\"1\"/><circle cx=\"33.5\" cy=\"8\" r=\"1\"/><circle cx=\"30\" cy=\"16\" r=\"1\"/></g>","JPY":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><circle cx=\"15\" cy=\"10\" r=\"6\" fill=\"#bc002d\"/>","CHF":"20 20|<rect width=\"20\" height=\"20\" fill=\"#da291c\"/><path d=\"M8 4h4v4h4v4h-4v4H8v-4H4V8h4z\" fill=\"#fff\"/>","SEK":"16 10|<rect width=\"16\" height=\"10\" fill=\"#006aa7\"/><path d=\"M5 0h2v10H5zM0 4h16v2H0z\" fill=\"#fecc00\"/>","NOK":"22 16|<rect width=\"22\" height=\"16\" fill=\"#ba0c2f\"/><path d=\"M6 0h4v16H6zM0 6h22v4H0z\" fill=\"#fff\"/><path d=\"M7 0h2v16H7zM0 7h22v2H0z\" fill=\"#00205b\"/>","DKK":"37 28|<rect width=\"37\" height=\"28\" fill=\"#c8102e\"/><path d=\"M12 0h4v28h-4zM0 12h37v4H0z\" fill=\"#fff\"/>","ISK":"25 18|<rect width=\"25\" height=\"18\" fill=\"#02529c\"/><path d=\"M7 0h4v18H7zM0 7h25v4H0z\" fill=\"#fff\"/><path d=\"M8 0h2v18H8zM0 8h25v2H0z\" fill=\"#dc1e35\"/>","PLN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#dc143c\"/>","CZK":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#d7141a\"/><path d=\"M0 0l15 10L0 20z\" fill=\"#11457e\"/>","HUF":"30 20|<rect width=\"30\" height=\"20\" fill=\"#cd2a3e\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#436f4d\"/>","RON":"30 20|<rect width=\"30\" height=\"20\" fill=\"#002b7f\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fcd116\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#ce1126\"/>","TRY":"30 20|<rect width=\"30\" height=\"20\" fill=\"#e30a17\"/><circle cx=\"10.5\" cy=\"10\" r=\"5\" fill=\"#fff\"/><circle cx=\"11.8\" cy=\"10\" r=\"4\" fill=\"#e30a17\"/><polygon points=\"19.5,10 17.9,10.5 17.9,12.2 16.9,10.8 15.3,11.4 16.3,10 15.3,8.6 16.9,9.2 17.9,7.8 17.9,9.5\" fill=\"#fff\"/>","ILS":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><path d=\"M0 2h30v3H0zM0 15h30v3H0z\" fill=\"#0038b8\"/><path d=\"M15 6.3l3.2 5.5h-6.4zM15 13.7l-3.2-5.5h6.4z\" fill=\"none\" stroke=\"#0038b8\" stroke-width=\".9\"/>","INR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#f93\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#138808\"/><circle cx=\"15\" cy=\"10\" r=\"2.4\" fill=\"none\" stroke=\"#000080\" stroke-width=\".7\"/>","SGD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ef3340\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#fff\"/><circle cx=\"6\" cy=\"5\" r=\"3.3\" fill=\"#fff\"/><circle cx=\"7.3\" cy=\"5\" r=\"3.2\" fill=\"#ef3340\"/><g fill=\"#fff\"><circle cx=\"9.6\" cy=\"3.2\" r=\".6\"/><circle cx=\"11.4\" cy=\"4.5\" r=\".6\"/><circle cx=\"10.7\" cy=\"6.6\" r=\".6\"/><circle cx=\"8.5\" cy=\"6.6\" r=\".6\"/><circle cx=\"7.8\" cy=\"4.5\" r=\".6\"/></g>","HKD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#de2910\"/><circle cx=\"15\" cy=\"7.4\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"17.47\" cy=\"9.2\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"16.53\" cy=\"12.1\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"13.47\" cy=\"12.1\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"12.53\" cy=\"9.2\" r=\"2.1\" fill=\"#fff\"/>","MXN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#006847\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fff\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#ce1126\"/><circle cx=\"15\" cy=\"10\" r=\"2.2\" fill=\"#8c6a2c\"/>","BRL":"30 20|<rect width=\"30\" height=\"20\" fill=\"#009b3a\"/><path d=\"M15 2.5L27.5 10 15 17.5 2.5 10z\" fill=\"#fedf00\"/><circle cx=\"15\" cy=\"10\" r=\"4.2\" fill=\"#002776\"/>","ZAR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#001489\"/><rect width=\"30\" height=\"10\" fill=\"#e03c31\"/><path d=\"M0 0l12 10L0 20\" fill=\"none\" stroke=\"#fff\" stroke-width=\"7\"/><rect x=\"11\" y=\"6.5\" width=\"19\" height=\"7\" fill=\"#fff\"/><path d=\"M0 0l12 10L0 20\" fill=\"none\" stroke=\"#007749\" stroke-width=\"4\"/><rect x=\"11\" y=\"8\" width=\"19\" height=\"4\" fill=\"#007749\"/><path d=\"M0 3.2L8.2 10 0 16.8z\" fill=\"#ffb612\"/><path d=\"M0 4.8L6.3 10 0 15.2z\" fill=\"#000\"/>","KRW":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><circle cx=\"15\" cy=\"10\" r=\"5\" fill=\"#0047a0\"/><path d=\"M10 10a5 5 0 0 1 10 0z\" fill=\"#cd2e3a\"/><g fill=\"#000\"><rect x=\"3.5\" y=\"3.4\" width=\"5\" height=\"2.4\" transform=\"rotate(34 6 4.6)\"/><rect x=\"21.5\" y=\"3.4\" width=\"5\" height=\"2.4\" transform=\"rotate(-34 24 4.6)\"/><rect x=\"3.5\" y=\"14.2\" width=\"5\" height=\"2.4\" transform=\"rotate(-34 6 15.4)\"/><rect x=\"21.5\" y=\"14.2\" width=\"5\" height=\"2.4\" transform=\"rotate(34 24 15.4)\"/></g>","CNY":"30 20|<rect width=\"30\" height=\"20\" fill=\"#de2910\"/><polygon points=\"5,2 5.7,4.1 7.9,4.1 6.1,5.4 6.8,7.4 5,6.1 3.2,7.4 3.9,5.4 2.1,4.1 4.3,4.1\" fill=\"#ffde00\"/><g fill=\"#ffde00\"><circle cx=\"10\" cy=\"2\" r=\".8\"/><circle cx=\"12\" cy=\"4\" r=\".8\"/><circle cx=\"12\" cy=\"7\" r=\".8\"/><circle cx=\"10\" cy=\"9\" r=\".8\"/></g>","PHP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#0038a8\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#ce1126\"/><path d=\"M0 0l17.3 10L0 20z\" fill=\"#fff\"/><circle cx=\"5.8\" cy=\"10\" r=\"1.9\" fill=\"#fcd116\"/>","MYR":"28 14|<rect width=\"28\" height=\"14\" fill=\"#fff\"/><path d=\"M0 0h28v1H0zM0 2h28v1H0zM0 4h28v1H0zM0 6h28v1H0zM0 8h28v1H0zM0 10h28v1H0zM0 12h28v1H0z\" fill=\"#cc0001\"/><rect width=\"14\" height=\"8\" fill=\"#010066\"/><circle cx=\"5.5\" cy=\"4\" r=\"2.8\" fill=\"#fc0\"/><circle cx=\"6.5\" cy=\"4\" r=\"2.4\" fill=\"#010066\"/><polygon points=\"10,2.4 10.4,3.5 11.5,3.5 10.6,4.2 10.9,5.3 10,4.6 9.1,5.3 9.4,4.2 8.5,3.5 9.6,3.5\" fill=\"#fc0\"/>","IDR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ce1126\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#fff\"/>","VND":"30 20|<rect width=\"30\" height=\"20\" fill=\"#da251d\"/><polygon points=\"15,4.8 16.3,8.7 20.3,8.7 17,11.1 18.3,14.9 15,12.5 11.7,14.9 13,11.1 9.7,8.7 13.7,8.7\" fill=\"#ff0\"/>","TWD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fe0000\"/><rect width=\"15\" height=\"10\" fill=\"#000095\"/><circle cx=\"7.5\" cy=\"5\" r=\"2.7\" fill=\"#fff\"/>","AED":"30 20|<rect width=\"30\" height=\"20\" fill=\"#00732f\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#000\"/><rect width=\"7.5\" height=\"20\" fill=\"#f00\"/>","SAR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#006c35\"/><rect x=\"7\" y=\"6\" width=\"16\" height=\"3\" rx=\"1\" fill=\"#fff\"/><rect x=\"7\" y=\"12.5\" width=\"16\" height=\"1\" fill=\"#fff\"/>","NGN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#008751\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fff\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#008751\"/>","KES":"30 20|<rect width=\"30\" height=\"20\" fill=\"#000\"/><rect y=\"6\" width=\"30\" height=\"14\" fill=\"#fff\"/><rect y=\"7\" width=\"30\" height=\"6\" fill=\"#b00\"/><rect y=\"14\" width=\"30\" height=\"6\" fill=\"#060\"/><ellipse cx=\"15\" cy=\"10\" rx=\"2.6\" ry=\"6\" fill=\"#b00\" stroke=\"#000\" stroke-width=\".6\"/>","PKR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#01411c\"/><rect width=\"7.5\" height=\"20\" fill=\"#fff\"/><circle cx=\"19\" cy=\"10\" r=\"5\" fill=\"#fff\"/><circle cx=\"20.4\" cy=\"8.9\" r=\"4.3\" fill=\"#01411c\"/><polygon points=\"23.3,5.8 23.1,6.8 24,7.3 23,7.4 22.7,8.4 22.3,7.5 21.3,7.6 22.1,6.9 21.7,6 22.5,6.5\" fill=\"#fff\"/>","EGP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ce1126\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#000\"/><circle cx=\"15\" cy=\"10\" r=\"1.8\" fill=\"#c09300\"/>","UAH":"30 20|<rect width=\"30\" height=\"20\" fill=\"#0057b7\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#ffd700\"/>","COP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fcd116\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#003893\"/><rect y=\"15\" width=\"30\" height=\"5\" fill=\"#ce1126\"/>","CLP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#d52b1e\"/><rect width=\"10\" height=\"10\" fill=\"#0039a6\"/><polygon points=\"5,2.6 5.5,4.3 7.3,4.3 5.9,5.3 6.4,6.9 5,5.9 3.6,6.9 4.1,5.3 2.7,4.3 4.5,4.3\" fill=\"#fff\"/>","PEN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#d91023\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fff\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#d91023\"/>","ARS":"30 20|<rect width=\"30\" height=\"20\" fill=\"#74acdf\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#74acdf\"/><circle cx=\"15\" cy=\"10\" r=\"1.8\" fill=\"#f6b40e\"/>","RUB":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#0039a6\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#d52b1e\"/>","BDT":"30 20|<rect width=\"30\" height=\"20\" fill=\"#006a4e\"/><circle cx=\"13.5\" cy=\"10\" r=\"5.5\" fill=\"#f42a41\"/>","MAD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#c1272d\"/><path d=\"M15 5.6l2.6 8-6.8-4.9h8.4l-6.8 4.9z\" fill=\"none\" stroke=\"#006233\" stroke-width=\".8\"/>","GHS":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ce1126\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fcd116\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#006b3f\"/><polygon points=\"15,7.3 15.7,9.4 17.9,9.4 16.1,10.7 16.8,12.7 15,11.4 13.2,12.7 13.9,10.7 12.1,9.4 14.3,9.4\" fill=\"#000\"/>"};
  var FLAG_CC = {"USD":"US","EUR":"EU","GBP":"GB","CAD":"CA","AUD":"AU","NZD":"NZ","JPY":"JP","CHF":"CH","SEK":"SE","NOK":"NO","DKK":"DK","PLN":"PL","CZK":"CZ","HUF":"HU","RON":"RO","ISK":"IS","TRY":"TR","ILS":"IL","INR":"IN","SGD":"SG","HKD":"HK","MXN":"MX","BRL":"BR","ZAR":"ZA","KRW":"KR","CNY":"CN","PHP":"PH","THB":"TH","MYR":"MY","IDR":"ID","AED":"AE","AFN":"AF","ALL":"AL","AMD":"AM","AOA":"AO","ARS":"AR","AWG":"AW","AZN":"AZ","BAM":"BA","BBD":"BB","BDT":"BD","BHD":"BH","BIF":"BI","BMD":"BM","BND":"BN","BOB":"BO","BSD":"BS","BTN":"BT","BWP":"BW","BYN":"BY","BZD":"BZ","CDF":"CD","CLP":"CL","COP":"CO","CRC":"CR","CVE":"CV","DJF":"DJ","DOP":"DO","DZD":"DZ","EGP":"EG","ERN":"ER","ETB":"ET","FJD":"FJ","FKP":"FK","GEL":"GE","GHS":"GH","GIP":"GI","GMD":"GM","GNF":"GN","GTQ":"GT","GYD":"GY","HNL":"HN","HTG":"HT","IQD":"IQ","JMD":"JM","JOD":"JO","KES":"KE","KGS":"KG","KHR":"KH","KMF":"KM","KWD":"KW","KYD":"KY","KZT":"KZ","LAK":"LA","LKR":"LK","LRD":"LR","LSL":"LS","LYD":"LY","MAD":"MA","MDL":"MD","MGA":"MG","MKD":"MK","MMK":"MM","MNT":"MN","MOP":"MO","MRU":"MR","MUR":"MU","MVR":"MV","MWK":"MW","MZN":"MZ","NAD":"NA","NGN":"NG","NIO":"NI","NPR":"NP","OMR":"OM","PAB":"PA","PEN":"PE","PGK":"PG","PKR":"PK","PYG":"PY","QAR":"QA","RSD":"RS","RUB":"RU","RWF":"RW","SAR":"SA","SBD":"SB","SCR":"SC","SDG":"SD","SHP":"SH","SLE":"SL","SOS":"SO","SRD":"SR","SSP":"SS","STN":"ST","SZL":"SZ","TJS":"TJ","TMT":"TM","TND":"TN","TOP":"TO","TTD":"TT","TWD":"TW","TZS":"TZ","UAH":"UA","UGX":"UG","UYU":"UY","UZS":"UZ","VND":"VN","VUV":"VU","WST":"WS","XAF":"\ud83c\udf0d","XCD":"\ud83c\udf0e","XCG":"CW","XOF":"\ud83c\udf0d","XPF":"\ud83c\udf0f","YER":"YE","ZMW":"ZM"};
  var OW_COUNTRIES = {"SHP":"ACSH","EUR":"ADATAXBEBGBLCYDEEEESFIFRGFGPGRHRIEITLTLULVMCMEMFMQMTNLPMPTRESISKSMTFVAXKYT","AED":"AE","AFN":"AF","XCD":"AGAIDMGDKNLCMSVC","ALL":"AL","AMD":"AM","AOA":"AO","USD":"AQASBQCUECFMGUIOIRKPLBMHMPPAPRPWSVSYTCTLUMUSVEVGVIZW","ARS":"AR","AUD":"AUCCCXHMKINFNRTV","AWG":"AW","AZN":"AZ","BAM":"BA","BBD":"BB","BDT":"BD","XOF":"BFBJCIGWMLNESNTG","BHD":"BH","BIF":"BI","BMD":"BM","BND":"BN","BOB":"BO","BRL":"BR","BSD":"BS","BTN":"BT","NOK":"BVNOSJ","BWP":"BW","BYN":"BY","BZD":"BZ","CAD":"CA","CDF":"CD","XAF":"CFCGCMGAGQTD","CHF":"CHLI","NZD":"CKNUNZPNTK","CLP":"CL","CNY":"CN","COP":"CO","CRC":"CR","CVE":"CV","XCG":"CWSX","CZK":"CZ","DJF":"DJ","DKK":"DKFOGL","DOP":"DO","DZD":"DZ","EGP":"EG","MAD":"EHMA","ERN":"ER","ETB":"ET","FJD":"FJ","FKP":"FK","GBP":"GBGGGSIMJETA","GEL":"GE","GHS":"GH","GIP":"GI","GMD":"GM","GNF":"GN","GTQ":"GT","GYD":"GY","HKD":"HK","HNL":"HN","HTG":"HT","HUF":"HU","IDR":"ID","ILS":"ILPS","INR":"IN","IQD":"IQ","ISK":"IS","JMD":"JM","JOD":"JO","JPY":"JP","KES":"KE","KGS":"KG","KHR":"KH","KMF":"KM","KRW":"KR","KWD":"KW","KYD":"KY","KZT":"KZ","LAK":"LA","LKR":"LK","LRD":"LR","LSL":"LS","LYD":"LY","MDL":"MD","MGA":"MG","MKD":"MK","MMK":"MM","MNT":"MN","MOP":"MO","MRU":"MR","MUR":"MU","MVR":"MV","MWK":"MW","MXN":"MX","MYR":"MY","MZN":"MZ","NAD":"NA","XPF":"NCPFWF","NGN":"NG","NIO":"NI","NPR":"NP","OMR":"OM","PEN":"PE","PGK":"PG","PHP":"PH","PKR":"PK","PLN":"PL","PYG":"PY","QAR":"QA","RON":"RO","RSD":"RS","RUB":"RU","RWF":"RW","SAR":"SA","SBD":"SB","SCR":"SC","SDG":"SD","SEK":"SE","SGD":"SG","SLE":"SL","SOS":"SO","SRD":"SR","SSP":"SS","STN":"ST","SZL":"SZ","THB":"TH","TJS":"TJ","TMT":"TM","TND":"TN","TOP":"TO","TRY":"TR","TTD":"TT","TWD":"TW","TZS":"TZ","UAH":"UA","UGX":"UG","UYU":"UY","UZS":"UZ","VND":"VN","VUV":"VU","WST":"WS","YER":"YE","ZAR":"ZA","ZMW":"ZM"};
  function own(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  function noop() {}
  function warn(name, e) { try { console.warn('[OpenWeav Booster] ' + name + ' stopped:', e && e.message ? e.message : e); } catch (x) {} }
  function safe(name, fn) { try { fn(); } catch (e) { warn(name, e); } }
  function unhold() {
    try { HTML.className = HTML.className.replace(/(^|\s)ow-cb-hold(?=\s|$)/g, ''); } catch (e) {}
  }
  function lsGet(k) { try { return W.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { W.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { W.localStorage.removeItem(k); } catch (e) {} }
  function raf(fn) { (W.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(fn); }
  function addClass(el, c) { if ((' ' + el.className + ' ').indexOf(' ' + c + ' ') === -1) el.className = (el.className ? el.className + ' ' : '') + c; }
  function removeClass(el, c) { el.className = (' ' + el.className + ' ').replace(' ' + c + ' ', ' ').replace(/^\s+|\s+$/g, ''); }
  function textNode(el, value) {
    /* One text node per element we own: later updates change nodeValue only (no removed nodes). */
    var t = D.createTextNode(value == null ? '' : String(value));
    el.appendChild(t);
    return t;
  }
  function setText(t, value) { value = value == null ? '' : String(value); if (t.nodeValue !== value) t.nodeValue = value; }
  function cleanText(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, ''); }

  var cfg = null;
  try {
    var cfgEl = D.getElementById('ow-booster-config');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent || 'null') : null;
  } catch (e) { cfg = null; }
  if (!cfg || !cfg.c || cfg.c.v !== 1) { unhold(); return; }
  var C = cfg.c, FX = cfg.fx || null, SHOP = cfg.shop || {}, PAGE = cfg.page || {};
  var BASE = String(SHOP.currency || 'USD').toUpperCase();
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || SHOP.root || '/';
  var PRODUCT = PAGE.t === 'product' && PAGE.p ? PAGE.p : null;

  /* ?ow_preview=1 \u2014 run every feature even while Vitals is still installed (for the store owner's check). */
  var PREVIEW = false;
  try {
    var pm = /[?&]ow_preview=([01])(?:&|$)/.exec(W.location.search || '');
    if (pm) W.sessionStorage.setItem('ow_cb_preview', pm[1]);
    PREVIEW = W.sessionStorage.getItem('ow_cb_preview') === '1';
  } catch (e) {}
  function vitalsHas(n) {
    if (PREVIEW) return false;
    try { var m = W.vtlsLiquidData && W.vtlsLiquidData.moduleSettings; return !!(m && m[String(n)]); } catch (e) { return false; }
  }

  /* \u2500\u2500 One body observer shared by every feature \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var subs = [], obs = null;
  function dispatch(recs) {
    for (var i = 0; i < subs.length; i++) { try { subs[i](recs); } catch (e) { warn('observer', e); } }
    /* Our own writes made during this callback are not news for us. */
    if (obs) { try { obs.takeRecords(); } catch (e) {} }
  }
  function onDom(fn) {
    subs.push(fn);
    if (obs || !W.MutationObserver || !D.body) return;
    obs = new MutationObserver(dispatch);
    obs.observe(D.body, { childList: true, subtree: true, characterData: true });
  }
  /* Once per frame, whatever changed (sticky mirror, labels, cart note). */
  function onDomFrame(fn) {
    var queued = false;
    onDom(function () {
      if (queued) return;
      queued = true;
      raf(function () { queued = false; try { fn(); } catch (e) { warn('frame', e); } });
    });
  }

  /* Bottom offset for the fixed buttons while the sticky bar shows. */
  function setLift(px) { try { HTML.style.setProperty('--ow-cb-lift', (px > 0 ? px : 0) + 'px'); } catch (e) {} }

  /* \u2500\u2500 1. Currency converter \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var OWB = { version: 1, base: BASE, currency: function () { return BASE; }, rate: function () { return 1; },
    format: function (cents, code) { return owFmt(Number(cents), code || BASE); }, convert: function (cents) { return Number(cents); },
    setCurrency: noop, onChange: noop };
  W.OWBooster = OWB;

  safe('currency', function () {
    var cur = C.currency;
    if (!cur || vitalsHas(30)) { unhold(); return; }
    var active = W.Shopify && W.Shopify.currency && W.Shopify.currency.active;
    var usable = !!FX && !!FX.rates && String(FX.base).toUpperCase() === BASE && BASE === 'USD' && typeof WeakMap === 'function' && !!D.createTreeWalker
      && (!active || String(active).toUpperCase() === BASE)
      /* Only a format whose prices the reader can find ("$8.99"): on "US$8.99" / "8.99 USD" the selector
         and the cart notice would show while nothing converts (fix 2026-10-07). */
      && owFormatOk(SHOP.moneyFormat);
    if (usable) {
      var age = Date.now() - Number(FX.ts);
      usable = age >= -129600000 && age <= 604800000;
    }
    if (!usable) { unhold(); return; }
    function convertible(code) { return !!code && code !== BASE && own(OW_CUR, code) && FX.rates[code] > 0; }
    /* The store owner's list: what EVERY shopper's box offers (the store currency first). */
    var OWNER = [BASE];
    for (var li = 0; li < (cur.list || []).length; li++) {
      var lc = String(cur.list[li]).toUpperCase();
      if (convertible(lc) && OWNER.indexOf(lc) === -1) OWNER.push(lc);
    }
    var AUTO = !!cur.auto;
    if (OWNER.length < 2 && !AUTO) { unhold(); return; }
    var CHOSEN = 'ow_cb_cur', GEO = 'ow_cb_geo', GEO_FRESH = 86400000, GEO_KEEP = 2592000000, PICK = '2:';
    /* Every country -> its currency (fx.ts), expanded from "currency: the countries' letters run together". */
    var COUNTRY_CUR = {};
    for (var ck in OW_COUNTRIES) {
      if (!own(OW_COUNTRIES, ck)) continue;
      for (var ci = 0; ci + 1 < OW_COUNTRIES[ck].length; ci += 2) COUNTRY_CUR[OW_COUNTRIES[ck].substr(ci, 2)] = ck;
    }
    function currencyOf(country) { country = String(country || '').toUpperCase(); return /^[A-Z]{2}$/.test(country) && own(COUNTRY_CUR, country) ? COUNTRY_CUR[country] : null; }
    /* The visitor's country as Shopify last told it, with its currency ({c, k, t}); asked again after a day, used at most 30 days. */
    function geoRead() {
      try {
        var g = JSON.parse(lsGet(GEO) || 'null'), age = g ? Date.now() - g.t : NaN;
        if (g && typeof g.c === 'string' && /^[A-Z]{2}$/.test(g.c) && age < GEO_KEEP && age > -GEO_FRESH) return g;
      } catch (e) {}
      return null;
    }
    var geo = AUTO ? geoRead() : null;
    /* An entry the first runtime wrote ({c, t}: no currency) gets its currency at once, so the next
       page's head guard can hold the prices \u2014 it carries no country table (review 2026-10-07: until
       Shopify was asked again a day later, every page flashed $ prices first). */
    if (geo && !own(geo, 'k')) { geo.k = currencyOf(geo.c); lsSet(GEO, JSON.stringify({ c: geo.c, k: geo.k, t: geo.t })); }
    /* The shopper's OWN location currency when the converter can show it (owner 2026-10-07: "the customer
       location should be the main picked currency"), for every country \u2014 not only the owner's list. */
    var OWN = null;
    function setOwn(code) { OWN = AUTO && convertible(code) ? code : null; }
    if (geo) setOwn(typeof geo.k === 'string' ? geo.k : currencyOf(geo.c));
    /* This shopper's box: the owner's list, and their own currency at the top when it is not in it \u2014 so a
       visitor from Thailand who switched to USD can always switch back to THB. Never stored in the
       owner's settings, never shown to anyone else. */
    var LIST = [];
    function rebuild() { LIST = OWNER.slice(); if (OWN && LIST.indexOf(OWN) === -1) LIST.unshift(OWN); }
    rebuild();
    function valid(code) { return !!code && LIST.indexOf(code) !== -1; }

    /* The shopper's hand pick, saved as PICK + code ("2:GBP"). A bare "GBP" was saved by the FIRST box,
       which offered only the owner's list: it never hides the shopper's own location currency when that
       one is not in the list \u2014 the pick was made without it (review 2026-10-07: a Thai visitor who had
       re-tapped USD there kept seeing $ prices, THB only at the top of the box). */
    function picked() {
      var v = lsGet(CHOSEN);
      if (!v) return null;
      if (v.slice(0, PICK.length) === PICK) v = v.slice(PICK.length);
      else if (OWN && OWNER.indexOf(OWN) === -1) return null;
      return valid(v) ? v : null;
    }
    /* Once the shopper's own currency is known, a first-box pick is settled for good: kept (as a PICK
       pick) when their currency was in that box, dropped when it was not. */
    function settleOldPick() {
      var v = lsGet(CHOSEN);
      if (!v || !OWN || v.slice(0, PICK.length) === PICK) return;
      if (OWNER.indexOf(OWN) !== -1 && valid(v)) lsSet(CHOSEN, PICK + v);
      else lsDel(CHOSEN);
    }

    /* The shopper's own pick wins (kept across pages and visits); otherwise their location's currency. */
    var current = BASE;
    var manual = picked();
    settleOldPick();
    if (manual) current = manual;
    else if (OWN) current = OWN;

    var rec = new WeakMap(); /* text node \u2192 { o: original store-currency text, w: what we wrote, n: writes, t: first write ms } */
    var listeners = [];
    function skipped(el) {
      for (var e = el, d = 0; e && e !== D.body && d < 60; e = e.parentNode, d++) {
        if (e.nodeType !== 1) continue;
        var tn = e.nodeName;
        if (tn === 'SCRIPT' || tn === 'STYLE' || tn === 'NOSCRIPT' || tn === 'TEXTAREA' || tn === 'TEMPLATE' || tn === 'TITLE' || tn === 'INPUT') return true;
        if (e.getAttribute && e.getAttribute('data-ow-noconv') !== null) return true;
        if (e.getAttribute && e.getAttribute('contenteditable') === 'true') return true;
        /* The review widget prints the customers' own words. (getAttribute: a form's .id can be its <input name="id">.) */
        var eid = e.getAttribute ? e.getAttribute('id') : null;
        if (eid && eid.indexOf('reviewify') === 0) return true;
      }
      return false;
    }
    var touchedButton = false;
    /* Loop guard. Another script that writes a price back to "$\u2026" each time we convert it (a
       second converter, a widget re-rendering from its own copy) would make the two observers
       call each other forever \u2014 inside one task, so the page would freeze. Every conversion
       that follows someone else's write (a new text node, or a node rewritten in place) is
       counted per parent element: more than 40 in 10 s and that element is left exactly as the
       other script writes it for the rest of the page view. Re-applying our own text (a
       currency switch) is not counted; a shopper switching packs makes 1 per switch. */
    var FIGHT_MAX = 40, FIGHT_MS = 10000;
    var fights = new WeakMap(); /* parent element \u2192 { n, t, x } */
    function gaveUp(el) { var f = el ? fights.get(el) : null; return !!(f && f.x); }
    function foreignWriteOk(el) {
      if (!el) return true;
      var now = Date.now(), f = fights.get(el);
      if (!f || now - f.t > FIGHT_MS) { f = { n: 0, t: now, x: false }; fights.set(el, f); }
      if (++f.n <= FIGHT_MAX) return true;
      f.x = true;
      warn('price', 'another script keeps rewriting a price; it is left as that script writes it');
      return false;
    }
    function apply(n) {
      var p = n.parentNode;
      if (!p) return; /* already replaced: nothing to show */
      var v = n.nodeValue, r = rec.get(n);
      var foreign = !r;
      if (r) {
        if (r.x) return;
        if (v !== r.w) { rec.delete(n); r = null; foreign = true; } /* someone else changed it: what they wrote is the new original */
      }
      var orig = r ? r.o : v;
      if (!orig || orig.indexOf('$') === -1) return;
      if (!r && skipped(p)) return;
      if (current === BASE) {
        if (r) { rec.delete(n); if (n.nodeValue !== r.o) n.nodeValue = r.o; }
        return;
      }
      if (gaveUp(p)) return;
      var out = owConvertText(orig, FX.rates[current], current);
      if (out == null) return;
      if (foreign && !foreignWriteOk(p)) return;
      var now = Date.now();
      if (r) {
        /* A node rewritten to our own text over and over (never by us) is left alone too. */
        if (now - r.t > 10000) { r.t = now; r.n = 0; }
        if (++r.n > 25) { r.x = true; return; }
      } else r = { o: orig, w: out, n: 1, t: now };
      r.o = orig; r.w = out;
      if (n.nodeValue !== out) n.nodeValue = out;
      rec.set(n, r);
      if (n.parentNode && n.parentNode.closest && n.parentNode.closest('[id^="ProductSubmitButton"]')) touchedButton = true;
    }
    function collect(root, out) {
      if (!root) return;
      if (root.nodeType === 3) { if ((root.nodeValue && root.nodeValue.indexOf('$') !== -1) || rec.has(root)) out.push(root); return; }
      if (root.nodeType !== 1 && root.nodeType !== 11) return;
      var tn = root.nodeName;
      if (tn === 'SCRIPT' || tn === 'STYLE' || tn === 'NOSCRIPT' || tn === 'TEMPLATE' || tn === 'TEXTAREA') return;
      var tw = D.createTreeWalker(root, 4, null, false), n;
      while ((n = tw.nextNode())) { if ((n.nodeValue && n.nodeValue.indexOf('$') !== -1) || rec.has(n)) out.push(n); }
    }
    /* The converted label can be wider than the store-currency one the bundle box measured:
       shorten it the same way the box does ("Add 4 patterns \u2013 \u00a3x" \u2192 "Add 4 \u2013 \u00a3x" \u2192 "Add \u2013 \u00a3x" \u2192 "\u00a3x").
       (The sticky bar is data-ow-noconv and fits its own copy of the label: see fitSticky.) */
    function refit(btnLabel) {
      if (!btnLabel || btnLabel.childNodes.length !== 1 || btnLabel.firstChild.nodeType !== 3) return;
      var n = btnLabel.firstChild, r = rec.get(n);
      if (!r || current === BASE) return;
      var fits = function () { try { return btnLabel.scrollWidth <= btnLabel.clientWidth + 1; } catch (e) { return true; } };
      if (fits()) return;
      var full = n.nodeValue, m = /^(.*?)\s+\u2013\s+(.+)$/.exec(full);
      if (!m) return;
      var cnt = /^Add (\d+)\b/.exec(m[1]);
      var options = [];
      if (cnt && m[1] !== 'Add ' + cnt[1]) options.push('Add ' + cnt[1] + ' \u2013 ' + m[2]);
      options.push('Add \u2013 ' + m[2], m[2]);
      for (var i = 0; i < options.length; i++) {
        n.nodeValue = options[i];
        r.w = options[i];
        if (fits()) return;
      }
    }
    function refitButtons() {
      if (!touchedButton) return;
      touchedButton = false;
      var labels = D.querySelectorAll('[id^="ProductSubmitButton"] > span');
      for (var i = 0; i < labels.length; i++) refit(labels[i]);
    }
    function applyAll() {
      var list = [];
      collect(D.body, list);
      for (var i = 0; i < list.length; i++) applySafe(list[i]);
      refitButtons();
    }
    /* One odd node never stops the converter. */
    function applySafe(n) { try { apply(n); } catch (e) { warn('price', e); } }
    function onMutations(recs) {
      var list = [];
      for (var i = 0; i < recs.length; i++) {
        var m = recs[i];
        if (m.type === 'characterData') { if (m.target.nodeType === 3) list.push(m.target); }
        else if (m.addedNodes) for (var j = 0; j < m.addedNodes.length; j++) collect(m.addedNodes[j], list);
      }
      if (!list.length) return;
      for (var k = 0; k < list.length; k++) {
        var n = list[k], r = rec.get(n);
        if (r && n.nodeValue === r.w) continue; /* ours */
        if (current === BASE && !r) continue;
        applySafe(n);
      }
      refitButtons();
    }

    /* Cart page: the shopper is told checkout is in the store currency. */
    var NOTE_ID = 'ow-cb-cart-note';
    function cartNote() {
      if (!cur.note || PAGE.t !== 'cart') return;
      var el = D.getElementById(NOTE_ID);
      if (current === BASE) { if (el) el.hidden = true; return; }
      var txt = 'Prices shown here are calculated in ' + current + ', but the final order will be paid in ' + BASE + '.';
      if (!el) {
        var blocks = D.querySelector('#main-cart-footer .cart__blocks') || D.querySelector('.cart__blocks');
        var totals = D.querySelector('.totals');
        if (!blocks && !totals) return;
        el = D.createElement('p');
        el.id = NOTE_ID;
        el.className = 'ow-cb-cart-note';
        el.setAttribute('data-ow-noconv', '');
        el.setAttribute('role', 'note');
        textNode(el, '');
        if (blocks) {
          var after = blocks.querySelector(':scope > .js-contents');
          if (after && after.nextSibling) blocks.insertBefore(el, after.nextSibling);
          else if (after) blocks.appendChild(el);
          else blocks.insertBefore(el, blocks.firstChild);
        } else totals.parentNode.insertBefore(el, totals.nextSibling);
      }
      setText(el.firstChild, txt);
      el.hidden = false;
    }

    /* Selector, fixed bottom-left (or right). */
    var sel = null;
    var WIN = false;
    try { WIN = /Windows/i.test((W.navigator && W.navigator.userAgent) || ''); } catch (e) {}
    /* A drawn flag ("w h|<shapes>", wrapped here); else the emoji built from the two country letters \u2014
       Windows draws an emoji flag as two plain letters, so there a small neat box with them instead. */
    function flag(code) {
      if (own(FLAG_SVG, code)) {
        var f = FLAG_SVG[code], bar = f.indexOf('|');
        return '<span class="ow-cb-flag"><svg viewBox="0 0 ' + f.slice(0, bar) + '" preserveAspectRatio="none" aria-hidden="true">' + f.slice(bar + 1) + '</svg></span>';
      }
      var cc = own(FLAG_CC, code) ? FLAG_CC[code] : '';
      if (/^[A-Z]{2}$/.test(cc)) {
        if (WIN) return '<span class="ow-cb-flag ow-cb-flag--txt" aria-hidden="true">' + cc + '</span>';
        cc = String.fromCharCode(0xD83C, 0xDDE6 + cc.charCodeAt(0) - 65, 0xD83C, 0xDDE6 + cc.charCodeAt(1) - 65);
      }
      return '<span class="ow-cb-flag ow-cb-flag--emoji" aria-hidden="true">' + cc + '</span>';
    }
    function buildSelector() {
      var wrap = D.createElement('div');
      wrap.className = 'ow-cb-cur ow-cb-fixed ow-cb-cur--' + (cur.pos === 'bottom_right' ? 'br' : 'bl');
      wrap.setAttribute('data-ow-noconv', '');
      wrap.style.setProperty('--ow-cur-bg', cur.bg || '#ffffff');
      wrap.style.setProperty('--ow-cur-bd', cur.bd || '#f4f4f4');
      wrap.style.setProperty('--ow-cur-fg', cur.fg || '#111111');
      wrap.style.setProperty('--ow-cur-fs', (cur.fs || 14) + 'px');
      var btn = D.createElement('button');
      btn.type = 'button';
      btn.className = 'ow-cb-cur__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      var list = D.createElement('ul');
      list.className = 'ow-cb-cur__list';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Currency');
      list.hidden = true;
      var made = {};
      function optionFor(code) {
        if (own(made, code)) return made[code];
        var li = D.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('data-code', code);
        li.tabIndex = -1;
        li.className = 'ow-cb-cur__opt';
        li.innerHTML = flag(code) + '<span class="ow-cb-cur__code">' + code + '</span><span class="ow-cb-cur__name">' + (own(OW_CUR, code) ? OW_CUR[code][2] : '') + '</span>';
        made[code] = li;
        return li;
      }
      /* The options follow LIST without ever removing a node (the cart guard re-checks the cart on
         removed nodes): the owner's list in order; the shopper's own currency on top; an own currency
         that is no longer theirs is only hidden. */
      function fill() {
        for (var i = 0; i < OWNER.length; i++) { var o = optionFor(OWNER[i]); if (!o.parentNode) list.appendChild(o); }
        for (var k in made) if (own(made, k) && OWNER.indexOf(k) === -1) made[k].hidden = k !== OWN;
        if (OWN && OWNER.indexOf(OWN) === -1) { var t = optionFor(OWN); if (!t.parentNode) list.insertBefore(t, list.firstChild); t.hidden = false; }
      }
      function shownItems() {
        var out = [];
        for (var i = 0; i < list.children.length; i++) if (!list.children[i].hidden) out.push(list.children[i]);
        return out;
      }
      fill();
      wrap.appendChild(list);
      wrap.appendChild(btn);
      function paint() {
        btn.innerHTML = flag(current) + '<span class="ow-cb-cur__code">' + current + '</span><span class="ow-cb-cur__caret" aria-hidden="true"></span>';
        btn.setAttribute('aria-label', 'Currency: ' + current + '. Change currency');
        var opts = list.children;
        for (var j = 0; j < opts.length; j++) opts[j].setAttribute('aria-selected', opts[j].getAttribute('data-code') === current ? 'true' : 'false');
      }
      function open() {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var on = list.querySelector('[aria-selected="true"]:not([hidden])') || shownItems()[0];
        if (on) on.focus();
      }
      function close(focusBtn) {
        if (list.hidden) return;
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (focusBtn) btn.focus();
      }
      btn.addEventListener('click', function (e) { e.preventDefault(); if (list.hidden) open(); else close(false); });
      list.addEventListener('click', function (e) {
        var li = e.target && e.target.closest ? e.target.closest('[data-code]') : null;
        if (!li || li.hidden) return;
        setCurrency(li.getAttribute('data-code'), true);
        close(true);
      });
      list.addEventListener('keydown', function (e) {
        var items = shownItems(), at = -1;
        for (var k = 0; k < items.length; k++) if (items[k] === D.activeElement) at = k;
        if (!items.length) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(items.length - 1, at + 1)].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(0, at - 1)].focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (at >= 0) { setCurrency(items[at].getAttribute('data-code'), true); close(true); } }
        else if (e.key === 'Escape' || e.key === 'Tab') close(e.key === 'Escape');
      });
      D.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); }, true);
      D.body.appendChild(wrap);
      paint();
      return { paint: paint, fill: function () { fill(); paint(); } };
    }

    function setCurrency(code, byShopper) {
      code = String(code || '').toUpperCase();
      if (!valid(code)) return;
      if (byShopper) lsSet(CHOSEN, PICK + code);
      if (code === current) return;
      current = code;
      applyAll();
      if (obs) { try { obs.takeRecords(); } catch (e) {} }
      if (sel) sel.paint();
      safe('cart note', cartNote);
      for (var i = 0; i < listeners.length; i++) { try { listeners[i](current); } catch (e) {} }
      try { D.dispatchEvent(new CustomEvent('ow:currency', { detail: { currency: current, base: BASE } })); } catch (e) {}
    }

    OWB.currency = function () { return current; };
    OWB.rate = function (code) { code = code || current; return code === BASE ? 1 : (FX.rates[code] || null); };
    OWB.convert = function (cents) { return current === BASE ? Number(cents) : owConv(Number(cents), FX.rates[current], current); };
    OWB.format = function (cents, code) { code = code || current; return code === BASE ? owFmt(Number(cents), BASE) : owFmt(owConv(Number(cents), FX.rates[code], code), code); };
    OWB.setCurrency = function (code) { setCurrency(code, true); };
    OWB.onChange = function (fn) { if (typeof fn === 'function') listeners.push(fn); };
    OWB.currencies = function () { return LIST.slice(); };

    /* Back/forward cache: a restored page keeps its live state, so a currency chosen on another page
       meanwhile (Back after choosing EUR on the cart) would show the old one (fix 2026-10-07). */
    W.addEventListener('pageshow', function (e) {
      if (!e || !e.persisted) return;
      safe('currency', function () { var m = picked(); if (m && m !== current) setCurrency(m, false); });
    });

    applyAll();
    unhold();
    onDom(onMutations);
    onDomFrame(function () { if (current !== BASE && PAGE.t === 'cart' && !D.getElementById(NOTE_ID)) cartNote(); });
    safe('cart note', cartNote);
    safe('currency selector', function () { if (LIST.length >= 2) sel = buildSelector(); });

    /* The visitor's country \u2014 Shopify's own lookup, asked at most once a day (remembered with its
       currency). Asked even after the shopper picked a currency by hand: their own currency must stay
       in their box. It never overrides that pick. */
    function follow(country) {
      var was = OWN;
      setOwn(currencyOf(country));
      if (OWN !== was) {
        rebuild();
        if (sel) sel.fill();
        else if (LIST.length >= 2) safe('currency selector', function () { sel = buildSelector(); });
      }
      var want = picked() || OWN || BASE;
      settleOldPick();
      if (want !== current) setCurrency(want, false);
    }
    if (AUTO && (!geo || Date.now() - geo.t >= GEO_FRESH) && W.fetch) {
      // Same call as the country-redirect snippet proven live on the stores (countryRedirectInstaller.ts).
      W.fetch(ROOT + 'browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'omit', headers: { Accept: 'application/json' } })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (j) {
          var dc = j && j.detected_values && j.detected_values.country;
          var c = dc && (dc.handle || dc.iso_code);
          if (!c || !/^[A-Za-z]{2}$/.test(c)) return;
          c = String(c).toUpperCase();
          lsSet(GEO, JSON.stringify({ c: c, k: currencyOf(c), t: Date.now() }));
          safe('currency', function () { follow(c); });
        })['catch'](noop);
    }
  });
  unhold();

  /* \u2500\u2500 2. Sticky add to cart \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('sticky', function () {
    var st = C.sticky;
    if (!st || !PRODUCT || vitalsHas(16)) return;
    function findForm() {
      var f = D.querySelector('form[data-type="add-to-cart"]');
      if (!f) { var pf = D.querySelector('product-form'); if (pf) f = pf.querySelector('form'); }
      if (!f) f = D.querySelector('form[action*="/cart/add"]');
      return f;
    }
    function findButton() {
      var f = findForm(), b = null;
      if (f) b = f.querySelector('button[type="submit"][name="add"]') || f.querySelector('button[type="submit"]') || f.querySelector('.product-form__submit');
      return b || D.querySelector('[id^="ProductSubmitButton"]');
    }
    var themeBtn = findButton();
    if (!themeBtn) return;
    function labelOf(b) {
      if (!b) return '';
      if (b.tagName === 'INPUT') return cleanText(b.value);
      var s = b.querySelector('span');
      return cleanText(s ? s.textContent : b.textContent);
    }
    function priceText() {
      var info = themeBtn.closest ? themeBtn.closest('.product__info-container, [id^="ProductInfo-"], .product') : null;
      var box = (info && info.querySelector('[id^="price-"] .price')) || D.querySelector('[id^="price-template"] .price') || null;
      if (!box) return '';
      var sale = (' ' + box.className + ' ').indexOf(' price--on-sale ') !== -1;
      var el = sale ? box.querySelector('.price__sale .price-item--sale') : box.querySelector('.price__regular .price-item--regular');
      return cleanText(el ? el.textContent : '');
    }
    /* The theme's price block of the CURRENT variant: its compare-at price, only while Dawn shows the
       variant on sale (compare-at above the price) \u2014 already in the shopper's currency. */
    function compareText() {
      var info = themeBtn.closest ? themeBtn.closest('.product__info-container, [id^="ProductInfo-"], .product') : null;
      var box = (info && info.querySelector('[id^="price-"] .price')) || D.querySelector('[id^="price-template"] .price') || null;
      if (!box || (' ' + box.className + ' ').indexOf(' price--on-sale ') === -1) return '';
      var el = box.querySelector('.price__sale s') || box.querySelector('.price__sale .price-item--regular');
      return cleanText(el ? el.textContent : '');
    }
    function shownEl(el) { try { return !!el && el.getClientRects().length > 0; } catch (e) { return false; } }
    /* The bundle box's OWN struck price of the selected pack ("\u00a324.75" in "\u00a324.75 separately", the
       classic box's full price) \u2014 read from the box, never computed here; '' when it shows none. */
    function packStrike() {
      var kb = D.getElementById('kbBox');
      if (!kb) return '';
      var views = kb.querySelectorAll('.kb-v'), root = null;
      for (var i = 0; i < views.length && !root; i++) if (shownEl(views[i])) root = views[i];
      var bar = (root || kb).querySelector('.kb-bar--selected');
      if (!bar) return '';
      var cands = bar.querySelectorAll('s, del, .kb-bar-full-price');
      for (var j = 0; j < cands.length; j++) {
        var t = cleanText(cands[j].textContent);
        if (/\d/.test(t) && shownEl(cands[j])) return t;
      }
      return '';
    }
    var bar = D.createElement('div');
    bar.className = 'ow-cb-sticky' + (st.mobile ? '' : ' ow-cb-sticky--nomob') + (st.desktop ? '' : ' ow-cb-sticky--nodesk');
    bar.setAttribute('data-ow-noconv', '');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.setAttribute('aria-hidden', 'true');
    bar.style.setProperty('--ow-st-bg', st.bg || '#ffffff');
    bar.style.setProperty('--ow-st-fg', st.fg || '#2e2e2e');
    bar.style.setProperty('--ow-st-btn-bg', st.btnBg || '#000000');
    bar.style.setProperty('--ow-st-btn-fg', st.btnFg || '#ffffff');
    var inner = D.createElement('div'); inner.className = 'ow-cb-sticky__in'; bar.appendChild(inner);
    if (PRODUCT.img) {
      var img = D.createElement('img');
      img.className = 'ow-cb-sticky__img'; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy'; img.decoding = 'async';
      img.src = String(PRODUCT.img);
      inner.appendChild(img);
    }
    var info = D.createElement('div'); info.className = 'ow-cb-sticky__info'; inner.appendChild(info);
    var titleEl = D.createElement('div'); titleEl.className = 'ow-cb-sticky__title'; info.appendChild(titleEl);
    var titleT = textNode(titleEl, PRODUCT.title || '');
    /* The price, then the old price struck through (like Vitals): "\u0e3f302.96 \u0e3f495.39". */
    var priceEl = D.createElement('div'); priceEl.className = 'ow-cb-sticky__price'; info.appendChild(priceEl);
    var nowEl = D.createElement('span'); nowEl.className = 'ow-cb-sticky__now'; priceEl.appendChild(nowEl);
    var priceT = textNode(nowEl, '');
    var wasEl = D.createElement('s'); wasEl.className = 'ow-cb-sticky__was'; priceEl.appendChild(wasEl);
    var wasT = textNode(wasEl, '');
    var btn = D.createElement('button'); btn.type = 'button'; btn.className = 'ow-cb-sticky__btn'; inner.appendChild(btn);
    var btnSpan = D.createElement('span'); btn.appendChild(btnSpan);
    var btnT = textNode(btnSpan, st.label || 'Add to Cart');
    D.body.appendChild(bar);

    /* "RM 58.76" (MYR) has neither a "$" nor a currency sign: every symbol the table prints counts
       (letters only when not inside a word), plus the old signs / "ABC 12" test (fix 2026-10-07). */
    var SYM_PRICE = (function () {
      var alts = ['\\$'];
      for (var k in OW_CUR) {
        if (!Object.prototype.hasOwnProperty.call(OW_CUR, k)) continue;
        var y = String(OW_CUR[k][0]).replace(/\s+$/, '');
        if (y) alts.push(y.replace(/[.*+?^$(){}|[\]\\]/g, '\\$&'));
      }
      return new RegExp('(?:^|[^A-Za-z])(?:' + alts.join('|') + ')\\s?\\d');
    })();
    function labelHasPrice(label) {
      return /\d/.test(label) && (/[$\u00a3\u20ac\u00a5\u20b9\u20a9\u20aa\u20ba\u20b1\u0e3f]|[A-Z]{3}\s?\d/.test(label) || SYM_PRICE.test(label));
    }
    var shown = false, past = false, lastTap = 0, srcLabel = null;
    /* The bar's button is narrower than the theme's (max 60% / 62% of the bar), so the pack label
       the bundle box fitted to the full-width theme button can be cut at its END \u2014 the price.
       Shorten our own copy the box's way ("Add 4 patterns \u2013 \u00a3x" \u2192 "Add 4 \u2013 \u00a3x" \u2192 "Add \u2013 \u00a3x" \u2192
       "\u00a3x"), whatever the currency (USD too). Written only when the source label changes (sync
       runs after every page change; writing full-then-short each time would never settle);
       a width or font change re-fits. */
    function fits() { try { return !btnSpan.clientWidth || btnSpan.scrollWidth <= btnSpan.clientWidth + 1; } catch (e) { return true; } }
    function fitSticky(label) {
      var opts = [label], m = /^(.*?)\s+\u2013\s+(.+)$/.exec(label);
      if (m) {
        var c = /^Add (\d+)\b/.exec(m[1]);
        if (c && m[1] !== 'Add ' + c[1]) opts.push('Add ' + c[1] + ' \u2013 ' + m[2]);
        opts.push('Add \u2013 ' + m[2], m[2]);
      }
      for (var i = 0; i < opts.length; i++) {
        setText(btnT, opts[i]);
        if (fits()) return;
      }
    }
    /* The price line never cuts the price: when the struck old price does not fit beside it (a 320 px
       phone, a long pack label), the old price is left out. Measured only when the texts or the
       width change (hiding is an attribute: the page observer never sees it, nothing loops). */
    var lastPrice = null;
    function setPrice(now, was) {
      setText(priceT, now);
      setText(wasT, was);
      nowEl.hidden = !now;
      var key = now + '|' + was + '|' + W.innerWidth;
      if (key === lastPrice) return;
      lastPrice = key;
      wasEl.hidden = !was;
      priceEl.hidden = !now && !was;
      if (was && !priceEl.hidden) {
        var w = priceEl.clientWidth;
        if (w && priceEl.scrollWidth > w + 1) { wasEl.hidden = true; priceEl.hidden = !now; }
      }
    }
    function refitSticky() { srcLabel = null; lastPrice = null; sync(); }
    function show(on) {
      on = !!on && !(btn.disabled && !labelOf(themeBtn));
      if (on === shown) return;
      shown = on;
      if (on) { addClass(bar, 'ow-cb-sticky--on'); bar.setAttribute('aria-hidden', 'false'); }
      else { removeClass(bar, 'ow-cb-sticky--on'); bar.setAttribute('aria-hidden', 'true'); }
      raf(function () { setLift(shown && bar.offsetHeight ? bar.offsetHeight : 0); });
    }
    function sync() {
      if (!themeBtn || !D.contains(themeBtn)) {
        var nb = findButton();
        if (nb && nb !== themeBtn) { themeBtn = nb; watch(); }
      }
      var label = labelOf(themeBtn) || st.label || 'Add to Cart';
      if (label !== srcLabel) { srcLabel = label; fitSticky(label); }
      var disabled = !!(themeBtn && (themeBtn.disabled || themeBtn.getAttribute('aria-disabled') === 'true'));
      btn.disabled = disabled;
      /* A pack label carries its own price ("Add 4 \u2013 \u00a312.60"): no second price beside it \u2014 only the box's
         own struck price of that pack, when the box shows one. Otherwise the variant's price and, when it
         is on sale, its compare-at price struck through. */
      var withPrice = labelHasPrice(label);
      var p = withPrice ? '' : priceText();
      setPrice(p, withPrice ? packStrike() : (p ? compareText() : ''));
      if (PRODUCT.title) setText(titleT, PRODUCT.title);
    }
    var io = null;
    function watch() {
      if (!W.IntersectionObserver || !themeBtn) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        show(past);
      });
      io.observe(themeBtn);
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var now = Date.now();
      if (now - lastTap < 1200) return; /* one tap = one add */
      lastTap = now;
      if (!themeBtn || !D.contains(themeBtn)) themeBtn = findButton();
      if (!themeBtn || themeBtn.disabled || themeBtn.getAttribute('aria-disabled') === 'true') return;
      /* The theme's own button: the bundle box's capture listener (when a pack is chosen) or
         the theme's product form handles the add \u2014 never this script. */
      themeBtn.click();
    });
    sync();
    watch();
    onDomFrame(sync);
    /* A currency switch: our own writes are dropped from the page observer, so follow the event too. */
    D.addEventListener('ow:currency', function () { safe('sticky', function () { lastPrice = null; sync(); }); });
    W.addEventListener('pageshow', function (e) { if (e && e.persisted) { lastTap = 0; refitSticky(); } });
    var resizeQueued = false, lastWidth = W.innerWidth;
    W.addEventListener('resize', function () {
      /* Width only: a phone's address bar showing / hiding changes the height on every scroll. */
      if (resizeQueued || W.innerWidth === lastWidth) return;
      resizeQueued = true;
      raf(function () { resizeQueued = false; lastWidth = W.innerWidth; refitSticky(); });
    });
    try {
      if (D.fonts) {
        if (D.fonts.ready && D.fonts.ready.then) D.fonts.ready.then(function () { safe('sticky fit', refitSticky); });
        if (D.fonts.addEventListener) D.fonts.addEventListener('loadingdone', function () { safe('sticky fit', refitSticky); });
      }
    } catch (e) {}
  });

  /* \u2500\u2500 3. Related products: printed by the theme section; hidden while Vitals still shows its own. \u2500\u2500 */
  safe('related', function () {
    if (C.related && vitalsHas(22)) addClass(HTML, 'ow-cb-vrp');
  });

  /* \u2500\u2500 4. Scroll to top \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('scroll top', function () {
    var t = C.scrollTop;
    if (!t) return;
    var b = D.createElement('button');
    b.type = 'button';
    b.className = 'ow-cb-top ow-cb-fixed ow-cb-top--' + (t.pos === 'bottom_left' ? 'bl' : 'br');
    b.setAttribute('aria-label', 'Back to top');
    b.setAttribute('data-ow-noconv', '');
    b.style.setProperty('--ow-top-bg', t.bg || '#111111');
    b.style.setProperty('--ow-top-fg', t.fg || '#ffffff');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 5l-7 7 1.4 1.4L11 8.8V20h2V8.8l4.6 4.6L19 12z" fill="currentColor"/></svg>';
    b.tabIndex = -1;
    D.body.appendChild(b);
    var on = false, queued = false;
    function check() {
      queued = false;
      var y = W.pageYOffset || HTML.scrollTop || 0;
      var want = y > Math.max(400, (W.innerHeight || 600) * 0.8);
      if (want === on) return;
      on = want;
      if (on) { addClass(b, 'ow-cb-top--on'); b.tabIndex = 0; } else { removeClass(b, 'ow-cb-top--on'); b.tabIndex = -1; }
    }
    W.addEventListener('scroll', function () { if (!queued) { queued = true; raf(check); } }, { passive: true });
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var reduce = false;
      try { reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (x) {}
      try { W.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (x) { W.scrollTo(0, 0); }
    });
    check();
  });

  /* \u2500\u2500 5. Inactive tab message \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('inactive tab', function () {
    var t = C.inactiveTab;
    if (!t || !t.message || vitalsHas(13) || typeof D.hidden === 'undefined') return;
    /* "shown" is what document.title reads back after we set it: the browser collapses spaces
       ("Come  back" reads "Come back"), so comparing with the raw message never matched (fix 2026-10-07). */
    var saved = null, shown = null;
    D.addEventListener('visibilitychange', function () {
      try {
        if (D.hidden) { if (saved === null) { saved = D.title; D.title = String(t.message); shown = D.title; } }
        else if (saved !== null) { if (D.title === shown) D.title = saved; saved = null; shown = null; }
      } catch (e) {}
    });
  });

  /* \u2500\u2500 6. Product label \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('label', function () {
    var L = C.label;
    if (!L || !(L.ids && L.ids.length) && !(L.handles && L.handles.length)) return;
    var IDS = {}, HANDLES = {}, i;
    for (i = 0; i < (L.ids || []).length; i++) IDS[String(L.ids[i])] = 1;
    for (i = 0; i < (L.handles || []).length; i++) HANDLES[String(L.handles[i]).toLowerCase()] = 1;
    function wanted(id, handle) { return (id && IDS[String(id)] === 1) || (handle && HANDLES[String(handle).toLowerCase()] === 1); }
    function make() {
      var el = D.createElement('span');
      el.className = 'ow-cb-label ow-cb-label--' + (L.layout === 'strip' ? 'strip' : L.layout === 'circle' ? 'circle' : 'rect');
      el.setAttribute('data-ow-noconv', '');
      el.setAttribute('aria-hidden', 'true');
      var s = el.style;
      s.background = L.bg; s.color = L.fg; s.fontSize = L.size + 'px'; s.opacity = String(Math.max(0, Math.min(100, L.o)) / 100);
      s.height = L.h + 'px';
      s.top = L.v + '%';
      if (L.layout === 'strip') { s.left = '0'; s.width = '100%'; s.borderRadius = '0'; s.transform = 'translateY(-' + L.v + '%)'; }
      else {
        var w = L.layout === 'circle' ? Math.max(L.w, L.h) : L.w;
        if (L.layout === 'circle') s.height = w + 'px';
        s.width = w + 'px';
        s.left = L.x + '%';
        s.borderRadius = L.layout === 'circle' ? '50%' : L.r + 'px';
        s.transform = 'translate(-' + L.x + '%, -' + L.v + '%)';
      }
      textNode(el, L.text);
      return el;
    }
    function host(el) {
      try { if (W.getComputedStyle(el).position === 'static') el.style.position = 'relative'; } catch (e) {}
      return el;
    }
    function ensure(container) {
      if (!container) return;
      for (var k = 0; k < container.children.length; k++) if ((' ' + container.children[k].className + ' ').indexOf(' ow-cb-label ') !== -1) return;
      host(container).appendChild(make());
    }
    /* The product page: the label goes on the FIRST image the shopper sees, never on the whole
       gallery (fix 2026-10-07). Dawn's desktop "stacked" and "columns" layouts put every image in one
       slider-component, so a % of the gallery drifted down (stacked) or landed on the second image
       (columns). The anchor is the active media item when it is shown (Dawn moves is-active to the
       variant's image, which it also puts first), else the first shown item; slider-component /
       media-gallery only for a gallery without Dawn's media items. When the anchor changes (a
       thumbnail click in the thumbnail layouts), a label is added there and the others are hidden \u2014
       never moved or removed (no removed nodes: the cart guard re-checks the cart on those). */
    function shownEl(el) { try { return !!el && el.getClientRects().length > 0; } catch (e) { return false; } }
    function galleryAnchor() {
      var g = D.querySelector('slider-component[id^="GalleryViewer"]') || D.querySelector('media-gallery') || D.querySelector('.product__media-wrapper');
      if (!g) return null;
      var items = g.querySelectorAll('.product__media-item');
      if (!items.length) return { box: g, scope: g };
      var act = g.querySelector('.product__media-item.is-active');
      if (shownEl(act)) return { box: act, scope: g };
      for (var k = 0; k < items.length; k++) if (shownEl(items[k])) return { box: items[k], scope: g };
      return { box: act || items[0], scope: g };
    }
    var galObs = null, galWatched = null, galQueued = false;
    function watchGallery(el) {
      /* Thumbnail layouts: a click only moves the is-active class (no node added) \u2014 follow it. */
      if (!el || el === galWatched || !W.MutationObserver) return;
      if (galObs) galObs.disconnect();
      galWatched = el;
      galObs = new MutationObserver(function () {
        if (galQueued) return;
        galQueued = true;
        raf(function () { galQueued = false; safe('label: product page', productPage); });
      });
      galObs.observe(el, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    function productPage() {
      if (!L.product || !PRODUCT || !wanted(PRODUCT.id, PRODUCT.handle)) return;
      var a = galleryAnchor();
      if (!a) return;
      watchGallery(a.scope.closest ? (a.scope.closest('media-gallery') || a.scope) : a.scope);
      var have = a.scope.querySelectorAll('.ow-cb-label'), mine = null, k;
      for (k = 0; k < have.length; k++) if (!mine && have[k].parentNode === a.box) mine = have[k];
      for (k = 0; k < have.length; k++) {
        var want = have[k] === mine ? '' : 'none';
        if (have[k].style.display !== want) have[k].style.display = want;
      }
      if (!mine) host(a.box).appendChild(make());
    }
    function cardIdentity(card) {
      var a = card.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
      var id = a ? (/-(\d+)$/.exec(a.getAttribute('id') || '') || [])[1] : null;
      var link = a || card.querySelector('a[href*="/products/"]');
      var h = link ? (/\/products\/([^\/?#]+)/.exec(link.getAttribute('href') || '') || [])[1] : null;
      try { if (h) h = decodeURIComponent(h); } catch (e) {}
      return { id: id, handle: h };
    }
    function cards() {
      if (!L.cards) return;
      var list = D.querySelectorAll('.card-wrapper');
      for (var k = 0; k < list.length && k < 400; k++) {
        var c = list[k], who = cardIdentity(c);
        if (!wanted(who.id, who.handle)) continue;
        ensure(c.querySelector('.card__inner') || c.querySelector('.card__media'));
      }
    }
    function run() { safe('label: product page', productPage); safe('label: cards', cards); }
    run();
    onDomFrame(run);
  });
})();
